const AVATAR_SIZES = ['small', 'medium', 'large']

export default {
  AVATAR_SIZES
}
